<div class="ui-welcome-user-panel">

  <p class="ui-welcome-user-panel__greeting">
    ¡Bienvenido, {{ userName() }}!
  </p>

  <div class="ui-welcome-user-panel__user">
    <ui-avatar
      class="ui-welcome-user-panel__avatar"
      [imageSrc]="avatarSrc()"
      [label]="avatarLabel()"
      [iconSrc]="avatarIconSrc()"
      [imageAlt]="avatarAlt()"
      [ariaLabel]="avatarAlt() || userName()"
      size="lg"
      shape="circle"
      tone="neutral"
    />
    <div class="ui-welcome-user-panel__meta">
      <span class="ui-welcome-user-panel__name">{{ userName() }}</span>
      @if (userRole()) {
        <span class="ui-welcome-user-panel__role">{{ userRole() }}</span>
      }
      @if (userEmail()) {
        <span class="ui-welcome-user-panel__email-row">
          <span class="ui-welcome-user-panel__email-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </span>
          <span class="ui-welcome-user-panel__email">{{ userEmail() }}</span>
        </span>
      }
    </div>
  </div>

  <div class="ui-welcome-user-panel__divider" role="separator"></div>

  <ul class="ui-welcome-user-panel__list" role="list">
    @for (item of items(); track item.id) {
      <li role="listitem">
        <button type="button" class="ui-welcome-user-panel__item" (click)="onItemClick(item.id)">
          <span class="ui-welcome-user-panel__item-icon-wrap" aria-hidden="true">
            @if (item.iconSrc) {
              <img class="ui-welcome-user-panel__item-icon-img" [src]="item.iconSrc" alt="" />
            } @else {
              @switch (resolveIcon(item)) {
                @case ('user') {
                  <svg class="ui-welcome-user-panel__item-svg" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                }
                @case ('notes') {
                  <svg class="ui-welcome-user-panel__item-svg" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                }
                @case ('tasks') {
                  <svg class="ui-welcome-user-panel__item-svg" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                  </svg>
                }
              }
            }
          </span>
          <span class="ui-welcome-user-panel__item-text">
            <span class="ui-welcome-user-panel__item-title">{{ item.title }}</span>
            <span class="ui-welcome-user-panel__item-sub">{{ item.subtitle }}</span>
          </span>
        </button>
      </li>
    }
  </ul>

  @if (systems().length) {
    <div class="ui-welcome-user-panel__divider" role="separator"></div>

    <div class="ui-welcome-user-panel__systems-wrap">
      <p class="ui-welcome-user-panel__systems-label">Mis sistemas</p>

      <ul class="ui-welcome-user-panel__systems" role="list">
        @for (system of systems(); track system.id) {
          <li role="listitem">
            <button
              type="button"
              class="ui-welcome-user-panel__system-btn"
              (click)="onSystemClick(system)"
            >
              <span class="ui-welcome-user-panel__system-dot" aria-hidden="true"></span>
              <span class="ui-welcome-user-panel__system-label">{{ system.label }}</span>
              <span class="ui-welcome-user-panel__system-arrow" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </span>
            </button>
          </li>
        }
      </ul>
    </div>
  }

</div>
